import React from 'react'
import MuiDivider from '@mui/material/Divider'
import Typography from '@mui/material/Typography'
import { InputFieldBase } from '../types'

type DividerProps = InputFieldBase & {}

export const Divider: React.FC<DividerProps> = ({ value }) => {
  return (
    <div>
      <MuiDivider sx={{ mb: 3 }} />
      {value && (
        <Typography variant="subtitle2" mb={3}>
          {value}
        </Typography>
      )}
    </div>
  )
}
